import { render, staticRenderFns } from "./ListarAdministradores.vue?vue&type=template&id=48b4b746&"
import script from "./ListarAdministradores.vue?vue&type=script&lang=js&"
export * from "./ListarAdministradores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports